document.addEventListener('DOMContentLoaded', () => {
    const spotifyElement = document.getElementById('spotify-current-track');
    if (!spotifyElement) return;

    async function fetchSpotifyTrack() {
        try {
            const res = await fetch('/wp-json/spotify/v1/current-track');
            const data = await res.json();

            const isWithinTimeRange = () => {
                const hour = new Date().getHours();
                return hour >= 8 && hour < 18;
            };

            // hide spotify element if no data, empty oobject or outside time range
            if (!data || Object.keys(data).length === 0 || !isWithinTimeRange()) {
                spotifyElement.style.display = 'none';
                return;
            }

            spotifyElement.style.display = 'flex';
            spotifyElement.querySelector('#spotify-track-name').textContent = data.name;
            spotifyElement.querySelector('#spotify-track-artists').textContent = data.artists;
            spotifyElement.querySelector('#spotify-track-image').src = data.image;
            spotifyElement.href = data.external;

        } catch (err) {
            console.error('Spotify fetch error:', err);
        }
    }

    fetchSpotifyTrack();
    setInterval(fetchSpotifyTrack, 10000);
});